import { memo } from 'react';

const TONE_CLASS_BY_VARIANT = {
  greenBlue: 'bg-[linear-gradient(90deg,#22c55e_0%,#38bdf8_45%,#2563eb_100%)]',
  bluePurple: 'bg-[linear-gradient(90deg,#2563eb_0%,#60a5fa_36%,#c026d3_100%)]',
};

const StreamingStatusBar = ({
  variant = 'greenBlue',
  className = '',
  minWidthClassName = 'min-w-[240px]',
  trackClassName = '',
  lineClassName = '',
  ariaLabel = 'Streaming status',
}) => {
  const toneClass = TONE_CLASS_BY_VARIANT[variant] ?? TONE_CLASS_BY_VARIANT.greenBlue;

  return (
    <div
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={50}
      className={['block w-full min-w-0', minWidthClassName, className].filter(Boolean).join(' ')}
    >
      <span
        className={[
          'relative block h-1 w-full overflow-hidden rounded-full bg-slate-400/30 dark:bg-slate-500/25',
          trackClassName,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <span
          className={[
            'absolute inset-0 block aims-streaming-status-gradient-shift',
            toneClass,
            lineClassName,
          ]
            .filter(Boolean)
            .join(' ')}
        />
      </span>
    </div>
  );
};

export default memo(StreamingStatusBar);
